export default "__VITE_ASSET__7c3f8cdc__"